export default "__VITE_ASSET__C3va4k5t__"